mutation NoteTripItemCreate($input: NoteTripItemCreateInput!) {
  noteTripItemCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
